import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';

const HotelAiLanding = Loadable(lazy(() => import('views/HotelAiLanding')));
const AuthLogin = Loadable(lazy(() => import('views/Authentication/Auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/Authentication/Auth/Register')));

const HotelAiRoutes = [
  {
    path: '/',
    element: <HotelAiLanding />
  },
  {
    path: '/hotel-ai',
    element: <HotelAiLanding />
  },
  {
    path: '/login',
    element: <AuthLogin />
  },
  {
    path: '/register',
    element: <AuthRegister />
  }
];

export default HotelAiRoutes;
